<script>
/* eslint-disable quotes */
import ElementUI from "element-ui";
let loading;
const startLoading = function (val) {
  if (!val) {
    val = "弈写努力加载中……";
  }
  console.log(loading)
  if (!loading) {
    loading = ElementUI.Loading.service({
      lock: true,
      text: val,
      background: "rgba(0, 0, 0, 0.7)"
    });
  } else {
    stopLoading();
    startLoading(val)
  }
};
const stopLoading = function () {
  if (loading) {
    loading.close();
    loading = null
  }
};
const silentLoading = function () {
  loading = new S()
}

function S () {
  this.close = function () {
  }
}

export default {
  startLoading: startLoading,
  stopLoading: stopLoading,
  silentLoading: silentLoading
};

</script>



// WEBPACK FOOTER //
// src/components/js/Loading.vue